import { log } from './logging';

import { getUserId } from '../utils';

const fetchRetried = require('@ambassify/fetch-retried');
const fetch = fetchRetried({
	delay: fetchRetried.exponential(100),
	retries: 5
});

const FIREBASE_API_URL = 'https://attn-labs-moen.firebaseio.com';

// POST => PUSH
// PUT => update value

// const OFFLINE = true;
const OFFLINE = false;

const getOfflineData = id => {
	switch(id) {
		case 'cq_2':
			return {
				"brush_teeth": 1,
				"coffee_tea": 2,
				"dont_know": 3,
				"drink_water": 4,
				"flush_toilet": 5,
				"shower_bath": 6,
				"total": 28,
				"wash_face": 7
			}
		case 'cq_3':
			return {"12-15":201,"16+":249,"5-7":395,"8-11":436,"<4":238,"total":1519}
		case "cq_4":
			return {
				afternoon: 1,
				early_morning: 2,
				evening: 3,
				late_afternoon: 4,
				late_evening: 5,
				morning: 6,
				total: 21
			}
		case "cq_5_1":
		case "cq_5_2":
		case "cq_5_3":
		case "cq_5_4":
		case "cq_5_5":
		case "cq_5_6":
		case "cq_5_7":
		case "cq_5_8":
		case "cq_5_9":
		case "cq_5_10":
		case "cq_5_11":
		case "cq_5_12":
			return {
				strongly_disagree: 1,
				disagree: 2,
				agree: 3,
				strongly_agree: 4,
				total: 10
			}
		default:
			log(`no offline data case for ${id}`)
			return {}
	}
}

export const createNewUser = async (userData) => {
	return fetch(`${FIREBASE_API_URL}/users.json`, {
		method: 'POST',
		headers: {
			"Content-Type": "application/json; charset=utf-8",
		},
		body: JSON.stringify(userData)
	})
	.then( response => response.json() )
	.then( response => response.name )
}

export const getQuestionData = async (questionId) => {
	// return new Promise( (resolve, reject) => {
	// 	setTimeout( () => {
	// 		// resolve(null);
	// 		// resolve(getOfflineData(questionId))
	// 		reject();
	// 	}, 2000);
	// })
	log('getting getQuestionData', questionId, `offline mode? ${OFFLINE}`);
	if(OFFLINE) {
		let data = getOfflineData(questionId);
		log(`We are in offline mode, question ${questionId} data: ${data}`)
		return data;
	} else {
		return fetch(`${FIREBASE_API_URL}/questions/${questionId}/counters.json`, {
			method: 'GET',
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			}
		})
		.then( response => {
			log(`successfully retrieved question ${questionId} data`);
			return response.json();
		})
	}
}


// const postUserQuestionData = async (questionId, voteId) => {
// 	let userId = getUserId();
// 	if(!userId) return;
// 	return fetch(`${FIREBASE_API_URL}/users/${userId}/votes.json`, {
// 		method: 'PUT',
// 		headers: {
// 			"Content-Type": "application/json; charset=utf-8",
// 		},
// 		body: JSON.stringify({
// 			[questionId]: voteId
// 		})
// 	})
// }

export const postQuestionData = async (questionId, value) => {
	let userId = getUserId();
	if(userId) {
		fetch(`${FIREBASE_API_URL}/questions/${questionId}/votes.json`, {
			method: 'POST',
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
			body: JSON.stringify({
				timestamp: new Date().getTime(),
				userId,
				vote: value
			})
		})
		.then( response => response.json() )
		.then( response => {
			return response;
			// postUserQuestionData(questionId, response)
		})
		.catch( err => console.warn(err) )
	}
}


// WEBPACK FOOTER //
// ./utils/api.js